import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Col, FormGroup, Input, Row, Spinner, Toast } from 'reactstrap'
import { getGeneralConfigurations, updateGeneralConfigurations } from 'src/services/general-config-service';
import { IGeneralConfiguration } from 'src/services/types';
import './style.css';
import { LoadingPage } from 'src/components/Common/LoadingPage';

export const GeneralConfigurations = () => {
    
    const [config, setConfig] = useState<IGeneralConfiguration | null>(null);
    const [loading, setLoading] = useState(false);
    // const [errorMessage, setErrorMessage] = useState('');

    const getConfig = async () => {
        setLoading(true);
        const res = await getGeneralConfigurations();
        setLoading(false);
        if (res.result === 'ok') {
            setConfig(res.data);
        } else {
            toast(res.message, { type: 'error'});
            console.log('error:', res.message);
        }
    }

    const onChange = async (key: keyof IGeneralConfiguration, value: boolean) => {
        setConfig({ ...config!, [key]: value });
        const res = await updateGeneralConfigurations({ [key]: value });
        if (res.result === 'ok') {
            toast('Configuration updated successfully', { type: 'success'});
        } else {
            setConfig({ ...config!, [key]: !value });
            toast(res.message, { type: 'error'});
            console.log('error:', res.message);
        }
    }

    useEffect(() => {
        getConfig();
    },[]);

  return (
    <>
      <div className="page-content" style={{height: '100vh'}} >
        <h3 className="mb-4 text-primary">General Configurations</h3>
        {
            loading ? 
                <div className='d-flex justify-content-center align-items-center' style={{height: '200px'}}>
                    <LoadingPage text='Loading configurations...'/>
                </div>
            : (
                <Row className='gap-5 py-5'>
                    <Col sm='12' className='d-flex justify-content-center align-items-center gap-3'>
                        <h4 className='mt-2'>
                            Registration validation by Admin
                        </h4>
                        <div>
                            <FormGroup switch className="switch-large">
                                <Input
                                    className='form-check-input'
                                    type="switch"
                                    checked={config?.isAdminVerificationActive}
                                    onChange={()=>onChange('isAdminVerificationActive', !config?.isAdminVerificationActive )}
                                />
                            </FormGroup>
                        </div>
                    </Col>
                    <Col sm='12' className='d-flex justify-content-center align-items-center gap-3'>
                        <h4 className='mt-2'>
                            Allow access to the application
                        </h4>
                        <div>
                            <FormGroup switch className="switch-large">
                                <Input
                                    className='form-check-input'
                                    type="switch"
                                    checked={!config?.isAccessAppDisabled}
                                    onChange={()=>onChange('isAccessAppDisabled', !config?.isAccessAppDisabled )}
                                />
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            )
        }
        </div>
    </>
  )
}
